export const getCurrentTime = (hoursToAdd = 0) => {
  const now = new Date();
  if (hoursToAdd !== 0) {
    now.setHours(now.getHours() + hoursToAdd);
  }

  return now.toLocaleTimeString("en-GB", {
    timeZone: "Europe/London",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

export const formatDateTime = (val) => {
  if (!val) return "-";
  
  let d;
  if (typeof val === "string" && !val.includes("T") && val.includes(":")) {
    const [h, m, s] = val.split(":");
    d = new Date();
    d.setHours(parseInt(h, 10), parseInt(m, 10), parseInt(s || 0, 10));
  } else {
    d = new Date(val);
  }

  if (isNaN(d.getTime())) return val;

  return d.toLocaleString("en-GB", {
    timeZone: "Europe/London",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const formatDate = (val) => {
  if (!val) return "-";

  const d = new Date(val);
  if (isNaN(d.getTime())) return val;

  return d.toLocaleDateString("en-GB", {
    timeZone: "Europe/London",
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const formatTime = (val) => {
  if (!val) return "--";

  let d;
  if (typeof val === "string" && !val.includes("T") && val.includes(":")) {
    const parts = val.split(":");
    d = new Date();
    d.setHours(parseInt(parts[0], 10), parseInt(parts[1], 10), parseInt(parts[2] || 0, 10));
  } else {
    d = new Date(val);
  }

  if (isNaN(d.getTime())) return val;

  return d.toLocaleTimeString("en-GB", {
    timeZone: "Europe/London",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const formatDateField = formatDate;

export const getLondonNow = () => {
  const now = new Date();
  const londonString = now.toLocaleString("en-GB", {
    timeZone: "Europe/London",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });

  const [datePart, timePart] = londonString.split(", ");
  const [day, month, year] = datePart.split("/");
  const [hour, minute, second] = timePart.split(":");

  return new Date(
    parseInt(year, 10),
    parseInt(month, 10) - 1,
    parseInt(day, 10),
    parseInt(hour, 10),
    parseInt(minute, 10),
    parseInt(second, 10)
  );
};

export const formatLondonDate = (date, pattern = "yyyy-MM-dd") => {
  if (!date) return "";

  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return "";

  const parts = {
    yyyy: d.getFullYear().toString(),
    MM: (d.getMonth() + 1).toString().padStart(2, "0"),
    dd: d.getDate().toString().padStart(2, "0"),
  };

  return pattern
    .replace("yyyy", parts.yyyy)
    .replace("MM", parts.MM)
    .replace("dd", parts.dd);
};

export const addDaysLondon = (date, days) => {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
};

export const startOfWeekLondon = (date, weekStartsOn = 1) => {
  const d = new Date(date);
  const day = d.getDay();
  const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  d.setDate(d.getDate() - diff);
  d.setHours(0, 0, 0, 0);
  return d;
};

export const endOfWeekLondon = (date, weekStartsOn = 1) => {
  const d = startOfWeekLondon(date, weekStartsOn);
  d.setDate(d.getDate() + 6);
  d.setHours(23, 59, 59, 999);
  return d;
};

export const formatDateTime24 = (val) => {
  if (!val) return "-";
  const d = new Date(val);
  if (isNaN(d.getTime())) return val;
  return d.toLocaleString("en-GB", {
    timeZone: "Europe/London",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};